import React, { useEffect, useState } from "react";
import { Form, Row, Col, Space, Button, Spin } from "antd";
import Notification from "../../../../../../components/common/notification/notification";
import { InputFields } from "components/common";
import { employeeService } from "api";
import { useAppDispatch, useAppSelector } from "../../../../../../redux/hooks";
import { dataFields as inputFieldsInit } from "./config";
import { getSGAPI } from "../../../../../../redux/reducer/employee";

const FormAdd = (props) => {
  const { data, closeModal, type, getListApi, paramss, setCurrentPage } = props;
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const employees = useAppSelector((state) => state.employeesReducer);
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (type == "Thêm") {
      form.resetFields();
    } else {
      form.setFieldsValue(data);
    }
  }, [data]);

  useEffect(() => {
    form.setFieldsValue({
      ...data,
    });
  }, [data]);

  useEffect(() => {
    dispatch(
      getSGAPI({
        page: 1,
        limit: 100,
      })
    );
  }, []);

  useEffect(() => {
    setOptionsSGFields(employees.SGList, "idSoGioTrenTuan");
  }, [employees.SGList]);

  const setOptionsSGFields = (list, soGioTuan) => {
    if (inputFieldsInit.find((field) => field.name === soGioTuan)) {
      inputFieldsInit.find((field) => field.name === soGioTuan).options =
        list?.map((item) => ({
          value: item.id,
          label: item.soGioTuan,
        }));
    }
  };

  const addApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();
    try {
      const params = {
        ...value,
        soGioTrenTuan: parseInt(value.soGioTrenTuan, 10),
        soNgayCongChuan: parseFloat(value.soNgayCongChuan), // Sử dụng parseFloat() cho số thập phân
      };
      const res = await employeeService.updateStandardWorkMonth(params);
      setLoading(false);
      if (res.code === 400) {
        Notification("error", res.message);
      } else {
        Notification("success", "Đã thêm mới thành công ");
        form.resetFields();
        closeModal();
      }

      await getListApi(paramss);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi thêm mới công chuẩn tháng");
    }
  };

  const editApi = async () => {
    setLoading(true);
    const value = form.getFieldsValue();

    try {
      const params = {
        ...value,
        id: data.id,
        soGioTrenTuan: parseInt(value.soGioTrenTuan, 10),
        soNgayCongChuan: parseFloat(value.soNgayCongChuan), // Sử dụng parseFloat() cho số thập phân
      };
      const res = await employeeService
        .updateStandardWorkMonth(params)
        .then((res) => {
          if (res.code === 400) {
            Notification("error", res.message);
          } else {
            Notification("success", "Đã chỉnh sửa thành công ");
          }
        });
      setLoading(false);
      closeModal();
      await getListApi(paramss);
    } catch (error) {
      setLoading(false);
      Notification("error", "Đã có lỗi khi sửa thông tin công chuẩn tháng ");
    }
  };

  const onFinish = () => {
    if (type == "Thêm") {
      addApi();
    } else {
      editApi();
    }
  };

  return (
    <div>
      <Spin spinning={loading}>
        <Form form={form} onFinish={onFinish}>
          <Space direction="vertical" style={{ width: "100%" }}>
            <Row gutter={[16, 8]}>
              <InputFields data={inputFieldsInit}></InputFields>
            </Row>
            <Row justify="end" style={{ marginTop: 12 }}>
              <Col>
                <Space>
                  <Button
                    onClick={closeModal}
                    style={{
                      backgroundColor: "red",
                      borderColor: "red",
                      color: "white",
                    }}
                  >
                    Hủy bỏ
                  </Button>
                  <Button htmlType="submit" type="primary">
                    Lưu lại
                  </Button>
                </Space>{" "}
              </Col>
            </Row>
          </Space>
        </Form>
      </Spin>
    </div>
  );
};
export default FormAdd;
